import type { ThemeComponentType } from '../types';

const getMaxWidth = (size: any) => {
  if (size === 'xl') {
    return '1880px';
  }

  return undefined;
};

export const Container: ThemeComponentType = {
  styles: (_theme, { size }) => ({
    root: {
      maxWidth: getMaxWidth(size),
    },
  }),
};
